(function () {
    // Skript je soucasti globalniho bundlu, ale reCAPTCHA se nacita jen na strankach
    // s formularem. Bez reCAPTCHA pole (= bez formulare) nic nedelej.
    var hasRecaptchaField = document.getElementById('contact_recaptchaResponse')
        || document.getElementById('newsletter_recaptchaResponse');
    if (!hasRecaptchaField) {
        return;
    }

    // Get token for a specific form
    function getToken(formId) {
        grecaptcha.execute(MyAjax.recaptcha_site_key, { action: 'submit' })
            .then(function (token) {
                var inputElement = document.getElementById(formId + '_recaptchaResponse');
                if (inputElement) {
                    inputElement.value = token;
                }
            })
            .catch(function () {});
    }

    // grecaptcha se z api.js nacita asynchronne - pockej, az bude k dispozici,
    // aby skript nespadl na "grecaptcha is not defined".
    function whenReady(cb) {
        if (typeof grecaptcha !== 'undefined' && typeof grecaptcha.ready === 'function') {
            grecaptcha.ready(cb);
        } else {
            setTimeout(function () { whenReady(cb); }, 100);
        }
    }

    whenReady(function () {
        getToken('contact');
        getToken('newsletter');

        // Refresh tokens every 2 minutes
        setInterval(function () {
            getToken('contact');
            getToken('newsletter');
        }, 120000);
    });
})();
